import SnackBar, { MessageType } from './SnackBar';

export default SnackBar;

export type { MessageType };
